import { render, staticRenderFns } from "./FlashCardSelector.vue?vue&type=template&id=67d59ca4&scoped=true&"
import script from "./FlashCardSelector.vue?vue&type=script&lang=js&"
export * from "./FlashCardSelector.vue?vue&type=script&lang=js&"
import style0 from "./FlashCardSelector.vue?vue&type=style&index=0&id=67d59ca4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d59ca4",
  null
  
)

export default component.exports